export class Snapshot {
  constructor(public timestamp: number, public value: string) {}
}
